import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

class HealthcareServicesService {
    private getHeaders() {
        return {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
        };
    }

    async getHealthcareServices(filters: any = {}) {
        const params = new URLSearchParams();
        
        if (filters.limit) params.append('limit', filters.limit.toString());
        if (filters.offset) params.append('offset', filters.offset.toString());
        if (filters.search) params.append('search', filters.search);
        if (filters.code) params.append('code', filters.code);
        if (filters.name) params.append('name', filters.name);
        if (filters.is_cur !== undefined) params.append('is_cur', filters.is_cur.toString());
        if (filters.specialization_id) params.append('specialization_id', filters.specialization_id);
        
        // Add timestamp to prevent cache 304 Not Modified
        params.append('_t', Date.now().toString());

        const response = await axios.get(`${API_BASE_URL}/api/healthcare-services?${params}`, {
            headers: this.getHeaders()
        });
        return response.data;
    }

    async getHealthcareServiceById(id: string) {
        const response = await axios.get(`${API_BASE_URL}/api/healthcare-services/${id}`, {
            headers: this.getHeaders()
        });
        return response.data;
    }

    async syncFromRecup() {
        const response = await axios.post(`${API_BASE_URL}/api/healthcare-services/sync`, {}, {
            headers: this.getHeaders()
        });
        return response.data;
    }

    async syncFilteredFromRecup(filters: any = {}) {
        const response = await axios.post(`${API_BASE_URL}/api/healthcare-services/sync-filtered`, filters, {
            headers: this.getHeaders()
        });
        return response.data;
    }

    async deleteHealthcareService(id: string) {
        const response = await axios.delete(`${API_BASE_URL}/api/healthcare-services/${id}`, {
            headers: this.getHeaders()
        });
        return response.data;
    }

    async getStats() {
        const response = await axios.get(`${API_BASE_URL}/api/healthcare-services/stats`, {
            headers: this.getHeaders()
        });
        return response.data;
    }

    async getSpecializations(
        sortBy: 'name' | 'code' = 'name', 
        sortOrder: 'asc' | 'desc' = 'asc'
    ) {
        const params = new URLSearchParams();
        params.append('sort_by', sortBy);
        params.append('sort_order', sortOrder);
        
        const response = await axios.get(`${API_BASE_URL}/api/healthcare-services/specializations?${params}`, {
            headers: this.getHeaders()
        });
        return response.data;
    }
}

export default new HealthcareServicesService();